import {
  Inserter,
  PartMenu,
  PartAdmin,
  PartFrontlogo,
  OverlayIndex,
  Wrapper,
  Link,
  OverlayOpen,
  PartScrollPos,
  PartScrollTopOnNavigate,
  DragAndDropContext,
  Icon,
  Image,
  PartIconmenu,
  PartCookieBanner,
  useLanguage,
} from "nystem-components";

import React from "react";
import app from "nystem";

import "./index.css";
import "./part/iconmenu.css";

let loaded = false;

const Index = () => {
  const lang = useLanguage();

  return (
    <DragAndDropContext>
      <>
        <main className="body">
          <PartScrollTopOnNavigate />
          <OverlayIndex>
            <Wrapper key="menu">
              <PartMenu />
            </Wrapper>
          </OverlayIndex>
          <Inserter match={app.settings.homePath}>
            <PartFrontlogo />
            <PartIconmenu />
            <PartScrollPos>
              {({ height }) => (
                <div style={{ height: height + 1, transition: "all 500ms" }} />
              )}
            </PartScrollPos>
            <PartScrollPos>
              {({ scrollTop }) => {
                if (scrollTop) loaded = true;
                if (!loaded) return null;
                return <Inserter key={`/page/all/${lang}`} source="/page/all" />;
              }}
            </PartScrollPos>
          </Inserter>
          <div className="icon-menu-top">
            <OverlayOpen overlayId="menu">
              <div>
                <Icon
                  className="h-12 w-12 p-2 sm:w-14 sm:h-14 mb-6 bg-white rounded-xl bg-opacity-20"
                  icon="bars"
                />
              </div>
            </OverlayOpen>
          </div>
          <Inserter match="/*" source="/language/switcher" className="fixed top-3 right-3 z-20" />
          <Inserter exclude={app.settings.homePath}>
            <Link renderAs="div" to={app.settings.homePath} className="center">
              <div className="page-logo-box">
                <Image src="/image/150x200/logo.png" className="w-full h-full" alt="Logo" />
              </div>
            </Link>
          </Inserter>
          <Inserter match="/blog*" className="blog container" />
          <Inserter match="/page/render/*" />
          <PartAdmin />
          <PartCookieBanner />
        </main>
      </>
    </DragAndDropContext>
  );
};
export default Index;
